import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './logs-root-page.component.html',
})
export class LogsRootPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/logs/logs-root-page.component.ts